import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';



/**
 * An image component that displays images with variable sources depending on an OA-platform specific set of image sizes.
 * 
 * In order to use, place a set of 3 images in https://cdn.outdooraccess.com/oa-assets/images with
 *  the following file name format:
 *   foo-large.jpg
 *   foo-med.jpg
 *   foo-sm.jpg
 * 
 *   Then in template, add: 
 *   <oaimage [imageName]="'foo'"> </oaimage>
 * 
 *   There are 2 additional properties that are optional: fileExtension and baseUrl
 *   <oaimage [imageName]="'foo'" [baseUrl]="'https://cdn.outdooraccess.com/oa-assets/different-path'" [fileExtension]="'png'" > </oaimage>
 *   
 */
@Component({
    selector: "oaimage",
    templateUrl: "./oaimage.component.html",
    styleUrls: ["./oaimage.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class OAImageComponent implements OnInit {
  private readonly _componentName = 'OAImageComponent';
  private _baseUrl: string = 'https://cdn.outdooraccess.com/oa-assets/images';
  private _imageName: string;
  private _fileExtension: string = 'jpg';

  public largeImageUrl: string;
  public mediumImageUrl: string;
  public smallImageUrl: string;

  constructor() {}

  ngOnInit() {

    this.buildSourceUrls();
  }

  public get baseUrl(): string {
    return this._baseUrl;
  }

  @Input()
  public set baseUrl(v: string) {
    this._baseUrl = v;

    this.buildSourceUrls();
  }

  public get imageName(): string {
    return this._imageName;
  }

  /**
   * Sets the image name (w/o size modifiers) For map-placeholder-large.jpg,map-placeholder-med.jpg,map-placeholder-sm.jpg, this value would be map-placeholder
   */
  @Input()
  public set imageName(v: string) {
    this._imageName = v;

    this.buildSourceUrls();
  }

  public get fileExtension(): string {
    return this._fileExtension;
  }

  /**
   * Sets file extension. Default is jpg
   */
  @Input()
  public set fileExtension(v: string) {
    this._fileExtension = v;

    this.buildSourceUrls();
  }


  /**
   * Builds the image source urls
   */
  private buildSourceUrls() {

    this.largeImageUrl =  `${this.baseUrl}/${this.imageName}-large.${this.fileExtension}`;

    this.mediumImageUrl =  `${this.baseUrl}/${this.imageName}-med.${this.fileExtension}`;

    this.smallImageUrl =  `${this.baseUrl}/${this.imageName}-sm.${this.fileExtension}`;


    
  }

}
